export const translations = {
  el: {
    nav: {
      home: "Αρχική",
      sifu: "Ο Sifu",
      classes: "Μαθήματα",
      wingchun: "Wing Chun",
      bookPage: "Το Βιβλίο",
      reviews: "Κριτικές",
      schedule: "Πρόγραμμα",
      gallery: "Gallery",
      blog: "Blog",
      contact: "Επικοινωνία",
      book: "Κλείσε Δοκιμαστικό",
    },
    hero: {
      badge: "Ιδιαίτερα Μαθήματα • Θεσσαλονίκη",
      title: "Η τέχνη του Wing Chun",
      subtitle: "Ο δρόμος της αμεσότητας",
      description:
        "Προσωπική εκπαίδευση με τον Sifu Νίκο Αγαθόπουλο. Πρακτική αυτοάμυνα, πειθαρχία και εσωτερική ισορροπία — προσαρμοσμένα στις δικές σας ανάγκες.",
      cta_primary: "Κλείσε δοκιμαστικό μάθημα",
      cta_secondary: "Μάθε περισσότερα",
    },
    home: {
      pillars_title: "Τρεις πυλώνες εκπαίδευσης",
      pillar1_title: "Προσωπική εκπαίδευση",
      pillar1_text: "Το μάθημα προσαρμόζεται στο επίπεδο, την ηλικία και τον προσωπικό σας στόχο.",
      pillar2_title: "Πρακτική αυτοάμυνα",
      pillar2_text: "Απλές, άμεσες και ρεαλιστικές αντιδράσεις σε πραγματικές καταστάσεις.",
      pillar3_title: "Άμεση διόρθωση",
      pillar3_text: "Συνεχής καθοδήγηση, τεχνική διόρθωση και προσωπική παρακολούθηση προόδου.",
      philosophy_title: "Η φιλοσοφία",
      philosophy_text:
        "Το Wing Chun δεν είναι ένα σύνολο τεχνικών — είναι ένας δρόμος εξέλιξης. Η οικονομία της κίνησης, η σωστή στάση, η απόσταση και η αντίληψη διαμορφώνουν έναν άνθρωπο με αυτοπεποίθηση και εσωτερική ηρεμία.",
      quote:
        "Είναι σαν ένα δάχτυλο που δείχνει το φεγγάρι. Μη συγκεντρώνεσαι στο δάχτυλο, γιατί θα χάσεις όλη την ουράνια δόξα.",
      quote_author: "Bruce Lee",
      classes_title: "Τα μαθήματα",
      view_all: "Δείτε όλα",
    },
    sifu: {
      title: "Sifu Νίκος Αγαθόπουλος",
      subtitle:
        "Ο δάσκαλος που καθοδηγεί τον μαθητή στον δρόμο της τέχνης, της πειθαρχίας και της προσωπικής εξέλιξης.",
      p1:
        "Ο Sifu Νίκος Αγαθόπουλος γεννήθηκε το 1962 στη Γερμανία και ήρθε στην Ελλάδα το 1974. Η ενασχόλησή του με τις πολεμικές τέχνες ξεκίνησε από νεαρή ηλικία, με βαθύ ενδιαφέρον για την αυτοάμυνα, την πειθαρχία και τη φιλοσοφία των ανατολικών τεχνών.",
      p2:
        "Μαθητής του Δασκάλου Γιώργου Τουζόγλου, εκπαιδεύτηκε συστηματικά στο Wing Chun και πιστοποιήθηκε ως δάσκαλος 3ου ανώτερου επιπέδου Χρυσής Ζώνης από την Ελληνική Ομοσπονδία Πολεμικών Τεχνών (Ε.Ο.Π.Τ.).",
      p3:
        "Το 2011 ίδρυσε στη Θεσσαλονίκη τη σχολή πολεμικών τεχνών «Η Αμεσότητα», την οποία διατήρησε μέχρι το τέλος του 2023. Από το 2023 συνεχίζει την πορεία του μέσα από προσωπική μελέτη, εξέλιξη και διδασκαλία, προσφέροντας ιδιαίτερα μαθήματα Wing Chun και αυτοάμυνας.",
      role_title: "Ο ρόλος του Sifu",
      role_text:
        "Δεν είναι απλώς κάποιος που μεταδίδει τεχνικές γνώσεις. Είναι ένας άνθρωπος που καθοδηγεί, εμπνέει και συνοδεύει τον μαθητή στην προσωπική του εξέλιξη — φύλακας της παράδοσης και πρότυπο συμπεριφοράς.",
    },
    classes: {
      title: "Τα Μαθήματα",
      subtitle: "Έξι τρόποι να ξεκινήσετε την πορεία σας",
      list: [
        { t: "Ιδιαίτερο μάθημα Wing Chun", d: "Πλήρης εκπαίδευση στις αρχές, τις τεχνικές και τη φιλοσοφία." },
        { t: "Ιδιαίτερο μάθημα αυτοάμυνας", d: "Πρακτική εστίαση σε άμεσες αντιδράσεις για πραγματικές καταστάσεις." },
        { t: "Γυναικεία αυτοάμυνα", d: "Τεχνικές προσαρμοσμένες με έμφαση στη σωστή θέση και απόσταση." },
        { t: "Μάθημα για δύο άτομα", d: "Για φίλους, ζευγάρια ή συγγενικά πρόσωπα που εκπαιδεύονται μαζί." },
        { t: "Εταιρικό σεμινάριο", d: "Εκπαίδευση προσωπικού με πρακτικές τεχνικές και συνεργασία." },
        { t: "Online καθοδήγηση", d: "Απομακρυσμένη εκπαίδευση με προσωπικές οδηγίες και ανατροφοδότηση." },
      ],
    },
    schedule: {
      title: "Πρόγραμμα Μαθημάτων",
      subtitle: "Ενδεικτικό εβδομαδιαίο πρόγραμμα — κλείνεται κατόπιν συνεννόησης",
    },
    gallery: {
      title: "Gallery",
      subtitle: "Στιγμές από την εκπαίδευση και την τέχνη",
    },
    blog: {
      title: "Blog",
      subtitle: "Άρθρα, σκέψεις και φιλοσοφία γύρω από το Wing Chun",
      read_more: "Διαβάστε περισσότερα",
      back: "← Πίσω στο Blog",
    },
    contact: {
      title: "Επικοινωνία",
      subtitle:
        "Ενδιαφέρεστε να μάθετε Wing Chun ή πρακτική αυτοάμυνα; Συμπληρώστε τη φόρμα και θα επικοινωνήσουμε άμεσα.",
      name: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      area: "Περιοχή",
      city: "Πόλη",
      class_type: "Είδος μαθήματος",
      message: "Μήνυμα",
      submit: "Αποστολή",
      success: "Το μήνυμά σας στάλθηκε επιτυχώς!",
      error: "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά.",
      info_title: "Στοιχεία επικοινωνίας",
      location: "Θεσσαλονίκη / Καλαμαριά",
      faq_title: "Συχνές ερωτήσεις",
      faqs: [
        { q: "Γίνεται να κάνω ένα δοκιμαστικό μάθημα;", a: "Ναι, υπάρχει η δυνατότητα για ένα πρώτο δοκιμαστικό μάθημα. Σκοπός του είναι να γνωριστούμε και να διαμορφωθεί ένα πρόγραμμα προσαρμοσμένο σε εσάς." },
        { q: "Σε ποιους απευθύνονται τα μαθήματα;", a: "Σε αρχάριους, προχωρημένους, γυναίκες, εφήβους και ενήλικες. Δεν χρειάζεται προηγούμενη εμπειρία." },
        { q: "Ποιο είναι το όφελος των ιδιαίτερων μαθημάτων;", a: "Η εκπαίδευση προσαρμόζεται στον ρυθμό σας με άμεση καθοδήγηση και προσωπικές διορθώσεις." },
        { q: "Χρειάζεται προηγούμενη εμπειρία;", a: "Όχι. Τα μαθήματα ξεκινούν από το μηδέν, με σταδιακή εξέλιξη." },
        { q: "Πού πραγματοποιούνται τα μαθήματα;", a: "Κατόπιν συνεννόησης. Η τοποθεσία, η συχνότητα και το πρόγραμμα καθορίζονται προσωπικά." },
      ],
    },
    class_types: [
      "Ιδιαίτερο μάθημα Wing Chun",
      "Ιδιαίτερο μάθημα αυτοάμυνας",
      "Γυναικεία αυτοάμυνα",
      "Μάθημα για δύο άτομα",
      "Εκπαίδευση προσωπικού / εταιρικό σεμινάριο",
      "Online καθοδήγηση",
      "Άλλο",
    ],
    areas: [
      "Άγιος Ιωάννης Καλαμαριάς",
      "Αμπελόκηποι",
      "Άνω Τούμπα",
      "Ασβεστοχώρι",
      "Θεσσαλονίκη Κέντρο",
      "Εύοσμος",
      "Ελευθέριο - Κορδελιό",
      "Επτάλοφος",
      "Ευκαρπία",
      "Καλαμαριά",
      "Μενεμένη",
      "Σταυρούπολη",
      "Κρήνη",
      "Νέα Κρήνη",
      "Πανόραμα",
    ],
    footer: {
      tagline: "Η τέχνη της αμεσότητας",
      quick_links: "Γρήγοροι σύνδεσμοι",
      follow: "Ακολουθήστε",
      rights: "Όλα τα δικαιώματα κατοχυρωμένα",
    },
    admin: {
      title: "Διαχείριση",
      password: "Κωδικός διαχειριστή",
      login: "Είσοδος",
      logout: "Έξοδος",
      tabs: { bookings: "Κρατήσεις", contact: "Μηνύματα", blog: "Blog", schedule: "Πρόγραμμα", gallery: "Gallery" },
    },
  },
  en: {
    nav: {
      home: "Home",
      sifu: "The Sifu",
      classes: "Classes",
      wingchun: "Wing Chun",
      bookPage: "The Book",
      reviews: "Reviews",
      schedule: "Schedule",
      gallery: "Gallery",
      blog: "Blog",
      contact: "Contact",
      book: "Book a Trial",
    },
    hero: {
      badge: "Private Lessons • Thessaloniki",
      title: "The Art of Wing Chun",
      subtitle: "The path of directness",
      description:
        "Private training with Sifu Nikos Agathopoulos. Practical self-defense, discipline and inner balance — tailored to your own needs.",
      cta_primary: "Book a trial lesson",
      cta_secondary: "Learn more",
    },
    home: {
      pillars_title: "Three pillars of training",
      pillar1_title: "Personal training",
      pillar1_text: "Lessons adapt to your level, age and personal goals.",
      pillar2_title: "Practical self-defense",
      pillar2_text: "Simple, direct and realistic reactions to real situations.",
      pillar3_title: "Immediate correction",
      pillar3_text: "Continuous guidance, technical correction and personal progress tracking.",
      philosophy_title: "The philosophy",
      philosophy_text:
        "Wing Chun is not a set of techniques — it is a path of growth. Economy of motion, correct stance, distance and awareness shape a person with confidence and inner calm.",
      quote:
        "It's like a finger pointing away to the moon. Don't concentrate on the finger, or you will miss all that heavenly glory.",
      quote_author: "Bruce Lee",
      classes_title: "The Classes",
      view_all: "View all",
    },
    sifu: {
      title: "Sifu Nikos Agathopoulos",
      subtitle:
        "The teacher who guides the student along the path of art, discipline and personal growth.",
      p1:
        "Sifu Nikos Agathopoulos was born in 1962 in Germany and came to Greece in 1974. His involvement with martial arts began at a young age, with deep interest in self-defense, discipline and Eastern philosophy.",
      p2:
        "Student of Master Georgios Touzoglou, he was systematically trained in Wing Chun and certified as a 3rd senior level Gold Belt instructor by the Hellenic Martial Arts Federation (E.O.P.T.).",
      p3:
        "In 2011 he founded the martial arts school 'The Directness' in Thessaloniki, which he maintained until the end of 2023. Since 2023 he continues his journey through personal study, growth and teaching, offering private Wing Chun and self-defense lessons.",
      role_title: "The role of the Sifu",
      role_text:
        "He is not just someone who imparts technical knowledge. He is a person who guides, inspires and accompanies the student through personal growth — keeper of tradition and role model.",
    },
    classes: {
      title: "The Classes",
      subtitle: "Six ways to begin your journey",
      list: [
        { t: "Private Wing Chun lesson", d: "Complete training in the principles, techniques and philosophy." },
        { t: "Private self-defense lesson", d: "Practical focus on immediate reactions for real situations." },
        { t: "Women's self-defense", d: "Techniques adapted with focus on correct positioning and distance." },
        { t: "Two-person lesson", d: "For friends, couples or relatives training together." },
        { t: "Corporate seminar", d: "Staff training with practical techniques and cooperation." },
        { t: "Online coaching", d: "Remote training with personal guidance and feedback." },
      ],
    },
    schedule: {
      title: "Class Schedule",
      subtitle: "Indicative weekly program — booking by appointment",
    },
    gallery: {
      title: "Gallery",
      subtitle: "Moments from training and the art",
    },
    blog: {
      title: "Blog",
      subtitle: "Articles, thoughts and philosophy around Wing Chun",
      read_more: "Read more",
      back: "← Back to Blog",
    },
    contact: {
      title: "Contact",
      subtitle:
        "Interested in learning Wing Chun or practical self-defense? Fill in the form and we will get back to you.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      area: "Area",
      city: "City",
      class_type: "Class type",
      message: "Message",
      submit: "Send",
      success: "Your message was sent successfully!",
      error: "An error occurred. Please try again.",
      info_title: "Contact details",
      location: "Thessaloniki / Kalamaria",
      faq_title: "Frequently asked questions",
      faqs: [
        { q: "Can I do a trial lesson?", a: "Yes, a first trial lesson is available. Its purpose is to get to know each other and shape a program tailored for you." },
        { q: "Who are the classes for?", a: "Beginners, advanced students, women, teenagers and adults. No prior experience required." },
        { q: "What is the benefit of private lessons?", a: "Training adapts to your own pace with immediate guidance and personal corrections." },
        { q: "Do I need previous experience?", a: "No. Lessons start from zero and progress gradually." },
        { q: "Where do the lessons take place?", a: "By appointment. Location, frequency and schedule are set personally." },
      ],
    },
    class_types: [
      "Private Wing Chun lesson",
      "Private self-defense lesson",
      "Women's self-defense",
      "Two-person lesson",
      "Corporate seminar",
      "Online coaching",
      "Other",
    ],
    areas: [
      "Agios Ioannis Kalamarias",
      "Ampelokipoi",
      "Ano Toumba",
      "Asvestochori",
      "Thessaloniki Center",
      "Evosmos",
      "Eleftherio - Kordelio",
      "Eptalofos",
      "Efkarpia",
      "Kalamaria",
      "Menemeni",
      "Stavroupoli",
      "Krini",
      "Nea Krini",
      "Panorama",
    ],
    footer: {
      tagline: "The art of directness",
      quick_links: "Quick links",
      follow: "Follow",
      rights: "All rights reserved",
    },
    admin: {
      title: "Admin",
      password: "Admin password",
      login: "Login",
      logout: "Logout",
      tabs: { bookings: "Bookings", contact: "Messages", blog: "Blog", schedule: "Schedule", gallery: "Gallery" },
    },
  },
};

export const useT = (lang) => translations[lang] || translations.el;
